import { useCallback, useEffect, useState } from "react";
import { MessagesService } from "../../../../../services/messages";
import { IMessage } from "../../../types/Message";
import dayjs from "dayjs";

export const usePollUnreads = (
  conversationId: string | undefined,
  mineNew: IMessage | null,
  onMsgSent: () => void
) => {
  const [unreads, setUnreads] = useState<IMessage[]>([]);

  const [isPolling, setIsPolling] = useState<boolean>(false);

  const getSortedUnreads = useCallback(
    (data: IMessage[]) => {
      const value: IMessage[] = mineNew ? [...data, mineNew] : data;

      return value.sort((a: IMessage, b: IMessage) => {
        return dayjs(a.sentAt).diff(dayjs(b.sentAt), "ms") > 0 ? 1 : -1;
      });
    },
    [mineNew]
  );

  const pullData = useCallback(async () => {
    try {
      if (conversationId && !isPolling) {
        setIsPolling(true);

        const data = await MessagesService.fetchUnreads(conversationId);

        const value: IMessage[] = getSortedUnreads(data);

        setUnreads(value);

        mineNew && onMsgSent();

        setIsPolling(false);
      }
    } catch {}
  }, [conversationId, getSortedUnreads, mineNew, onMsgSent, isPolling]);

  useEffect(() => {
    const i = setInterval(async () => {
      await pullData();
    }, 2000);

    return () => clearInterval(i);
  }, [pullData]);

  return { unreads };
};
